import dayjs from 'dayjs';

import type { OpportunityOldType, OpportunityType } from '@/api/opportunity';
import { DateISOFormat } from '@/constants';

/**
 * Gets the start and end date of an opportunity. If the end date is not set or occurs after
 * today's date, it will be set to today's date.
 *
 * @param opportunity - The opportunity to get the date range for
 * @returns The start and end date of the opportunity
 */
export const getOpportunityDateRange = (opportunity?: OpportunityType | OpportunityOldType) => {
  const startDate = opportunity?.influenceStartDate;
  let endDate = opportunity?.closeDate;

  if (!endDate || dayjs(endDate).isAfter(dayjs())) {
    endDate = dayjs().format(DateISOFormat);
  }

  return {
    startDate,
    endDate,
  };
};
